import { QueryClient } from '@tanstack/react-query';
import { queryConfig } from './query-config';

/**
 * Global QueryClient instance for TanStack Query
 * 
 * Purpose: Manages server state caching, refetching, and synchronization
 * 
 * Why TanStack Query?
 * - Automatic caching and background refetching
 * - Request deduplication (multiple components can safely request same data)
 * - Optimistic updates for better UX
 * - Automatic retry on network failures
 * - Built-in loading and error states
 * - DevTools for debugging
 * 
 * Configuration is imported from query-config.ts
 */
export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
});
